<div class="iframe-wrapper">
    <iframe [src]="url | safeUrl" frameborder="0"></iframe>
</div>
